import type { HelpFile } from '../../types/help'
import { FilterPanelTestIds } from '../../../testids/FilterPanelTestIds'

export const filterPanelHelp: HelpFile = {
  docPage: '/docs/help-system/filters',
  texts: {
    [FilterPanelTestIds.filterPanel]:
      'Complex filter conditions over the columns of this list — each chip narrows the result set.',
    [FilterPanelTestIds.filterPanelTitle]: null,
    [FilterPanelTestIds.btnFilterApply]:
      'Apply the staged filters and refresh the list — active filters appear as chips above the table.',
    [FilterPanelTestIds.btnFilterClearAll]:
      'Remove every active filter and show the full unfiltered list.',
  },
}
